const WORKER_URL = 'https://spaceportfolio-api.rajansudhan0.workers.dev';

let projectsCache = null;
let projectsFetchPromise = null;

export async function fetchProjects(forceRefresh = false, adminKey = null) {
  if (forceRefresh || adminKey) {
    projectsCache = null;
    projectsFetchPromise = null;
  }
  if (projectsCache && !adminKey) return projectsCache;
  if (projectsFetchPromise && !adminKey) return projectsFetchPromise;

  const headers = {};
  if (adminKey) headers['X-Admin-Key'] = adminKey;

  const options = {
    headers,
    ...(forceRefresh ? { cache: 'no-store' } : {})
  };

  const p = fetch(`${WORKER_URL}/api/projects`, options)
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.json();
    })
    .then(data => {
      const results = Array.isArray(data) ? data : [];
      if (!adminKey) projectsCache = results;
      return results;
    })
    .catch(error => {
      console.error('Cloudflare fetch error:', error.message);
      if (!adminKey) projectsFetchPromise = null;
      return [];
    });

  if (!adminKey) projectsFetchPromise = p;
  return p;
}

export async function fetchProjectById(id, adminKey = null) {
  try {
    const headers = {};
    if (adminKey) headers['X-Admin-Key'] = adminKey;
    
    const response = await fetch(`${WORKER_URL}/api/projects/${id}`, { headers });
    if (!response.ok) throw new Error('Project not found');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('fetchProjectById error:', error.message);
    return null;
  }
}

export async function fetchFilters() {
  try {
    const response = await fetch(`${WORKER_URL}/api/projects/filters`);
    if (!response.ok) throw new Error('Filters fetch failed');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('fetchFilters error:', error.message);
    return { types: [], industries: [] };
  }
}

// Blog Service
export async function fetchPosts(forceRefresh = false, adminKey = null) {
  try {
    const headers = {};
    if (adminKey) headers['X-Admin-Key'] = adminKey;

    const options = {
      headers,
      ...(forceRefresh ? { cache: 'no-store' } : {})
    };

    const response = await fetch(`${WORKER_URL}/api/posts`, options);
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('fetchPosts error:', error.message);
    return [];
  }
}

export async function fetchPostById(id, adminKey = null) {
  try {
    const headers = {};
    if (adminKey) headers['X-Admin-Key'] = adminKey;

    const response = await fetch(`${WORKER_URL}/api/posts/${id}`, { headers });
    if (!response.ok) throw new Error('Post not found');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('fetchPostById error:', error.message);
    return null;
  }
}

export async function incrementBlogPostView(id) {
  try {
    const response = await fetch(`${WORKER_URL}/api/posts/increment-view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('incrementBlogPostView error:', error.message);
    return null;
  }
}

export async function fetchBlogFilters() {
  try {
    const response = await fetch(`${WORKER_URL}/api/posts/filters`);
    if (!response.ok) throw new Error('Filters fetch failed');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('fetchBlogFilters error:', error.message);
    return { categories: [], tags: [] };
  }
}

// Resume Service (Cached)
let resumeCache = null;
let resumeFetchPromise = null;

export async function fetchResumeData(forceRefresh = false, adminKey = null) {
  if (forceRefresh || adminKey) {
    resumeCache = null;
    resumeFetchPromise = null;
  }
  if (resumeCache && !adminKey) return resumeCache;
  if (resumeFetchPromise && !adminKey) return resumeFetchPromise;

  const headers = {};
  if (adminKey) headers['X-Admin-Key'] = adminKey;

  const options = {
    headers,
    ...(forceRefresh ? { cache: 'no-store' } : {})
  };

  const p = fetch(`${WORKER_URL}/api/resume`, options)
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.json();
    })
    .then(data => {
      const results = Array.isArray(data) ? data : [];
      if (!adminKey) resumeCache = results;
      return results;
    })
    .catch(error => {
      console.error('fetchResumeData error:', error.message);
      if (!adminKey) resumeFetchPromise = null;
      return [];
    });

  if (!adminKey) resumeFetchPromise = p;
  return p;
}

// Publications Service
let publicationsCache = null;
let publicationsFetchPromise = null;

export async function fetchPublications(forceRefresh = false, adminKey = null) {
  if (forceRefresh || adminKey) {
    publicationsCache = null;
    publicationsFetchPromise = null;
  }
  if (publicationsCache && !adminKey) return publicationsCache;
  if (publicationsFetchPromise && !adminKey) return publicationsFetchPromise;

  const headers = {};
  if (adminKey) headers['X-Admin-Key'] = adminKey;

  const options = {
    headers,
    ...(forceRefresh ? { cache: 'no-store' } : {})
  };

  const p = fetch(`${WORKER_URL}/api/publications`, options)
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.json();
    })
    .then(data => {
      const results = Array.isArray(data) ? data : [];
      if (!adminKey) publicationsCache = results;
      return results;
    })
    .catch(error => {
      console.error('fetchPublications error:', error.message);
      if (!adminKey) publicationsFetchPromise = null;
      return [];
    });

  if (!adminKey) publicationsFetchPromise = p;
  return p;
}
